export const colors = {
  green: '#5DBDB0',
  blue: '#5FBEB1',
  darkBlue: '#2e3d3b',
  orange: '#14685C',
}
